import AdjudicatingDecision from '@/components/Room/AdjudicatingDecision'

const AdjudicationScreen = () => {
  return <AdjudicatingDecision />
}

export default AdjudicationScreen
